var map = {
	"./Asset 1-8.png": "ca37",
	"./Data-Blog-Size-1024x546.png": "6704",
	"./Smart-Farming.png": "cd4d",
	"./asari.png": "1885",
	"./cmgp.png": "2a9e0",
	"./domaine.png": "e304",
	"./logo2---.png": "9154",
	"./logo2.png": "440d",
	"./logo2_.png": "aae8",
	"./logo2____.png": "8388",
	"./logo2_agriedge.png": "1f1c",
	"./logo2dd.png": "9c9d",
	"./logo2ddd.png": "f871",
	"./logo2zz.png": "bca5",
	"./logo_.png": "b4cb",
	"./logo_11.png": "16fa",
	"./ocp.png": "536f",
	"./ocpfff.png": "16ea",
	"./snf.png": "4f28",
	"./zniber.png": "aeb3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";